import HocHead from "@/Components/HigherOrderComponent/HocHead";
import { GetServerSideProps, NextPage } from "next";
import dynamic from "next/dynamic";
import Image from "next/image";

const ParseHtml = dynamic(() => import("@/common/ParseHtml"));

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL || "";

// Types for API response
interface SeoData {
  metaTitle?: string;
  metaDescription?: string;
  [key: string]: any;
}

interface TermsPolicyData {
  title?: string;
  content?: string;
  seo?: SeoData;
}

interface TermsPolicyProps {
  data: TermsPolicyData;
}

export const getServerSideProps: GetServerSideProps<TermsPolicyProps> = async ({
  res,
}) => {
  res.setHeader(
    "Cache-Control",
    "public, s-maxage=3600, stale-while-revalidate=59",
  );

  let data: TermsPolicyData = {};

  try {
    const apiRes = await fetch(`${baseUrl}term?populate=deep`);
    const apiResData = await apiRes.json();
    data = apiResData?.data?.attributes || {};
  } catch (error) {
    console.error("Error fetching terms policy:", error);
  }

  return {
    props: {
      data,
    },
  };
};

const TermsPolicy: NextPage<TermsPolicyProps> = ({ data }) => {
  const { content = "" } = data;

  return (
    <>
      {data.seo && <HocHead seo={data.seo} />}
      <TermsBanner data={data} />
      <section className="xl:py-[80px] lg:py-[60px] py-[40px]">
        <div className="container">
          <div className="htmlString-inner">
            <ParseHtml htmlString={content} />
          </div>
        </div>
      </section>
    </>
  );
};

const TermsBanner: React.FC<TermsPolicyProps> = (props) => {
  return (
    <>
      <section className="request-proposal-banner bg-background-dark pt-[144px] lg:pt-[154px] xl:pt-[180px] pb-[60px] lg:pb-[80px] xl:pb-[100px] relative z-0 overflow-hidden">
        {/* Shapes */}
        <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
          <Image
            src="/images/banner-left-layer-mobile.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-left-layer-tablet.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-left-layer-desktop.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden lg:block"
          />
        </div>
        <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
          <Image
            src="/images/banner-right-layer-mobile.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-right-layer-tablet.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-right-layer-desktop.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden lg:block"
          />
        </div>
        <div className="container lg:p-[0px_24px]!">
          <div>
            <h1 className="text-white text-heading-2 font-extrabold text-center max-w-[824px] mx-auto">
              {props?.data?.title}
            </h1>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsPolicy;
